import React from 'react';
import './WhatsappSection.css';

export default function WhatsappSection() {
    const phoneNumber = "9776522386"; // Replace with your WhatsApp number
  const message = encodeURIComponent("Hello, I need help with your consulting services.");
  return (
    <>
    <div className="whatsapp-section">
      <h2>Chat with Us on WhatsApp</h2>
      <p>Need assistance or have queries about our consulting services? Chat with us instantly on WhatsApp!</p>

      <a
        href={`https://wa.me/${phoneNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp Icon"
          className="whatsapp-icon"
        />
        Chat Now
      </a>
    </div>
    
    
    </>
  )
}
